// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'Loading the change…',
  load_failed: "I couldn't load this change.",
  load_retry: 'Try again',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'This was already approved, so there was nothing more to do.',
  action_failed: "That didn't go through, so nothing changed. Try again in a moment.",
  removed: 'Removed',
  retry: 'Try again',
  retry_one: 'Try {{name}} again',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Approved.',
    retried: 'Tried again.',
    rejected: 'Rejected.',
  },
  done: {
    summary_one: 'Done. {{count}} change applied.',
    summary_other: 'Done. {{count}} changes applied.',
    skipped_one: '{{count}} skipped, nothing changed for it.',
    skipped_other: '{{count}} skipped, nothing changed for them.',
  },
  partial: {
    summary_one: "{{applied}} of {{approved}} changes applied. {{count}} didn't.",
    summary_other: "{{applied}} of {{approved}} changes applied. {{count}} didn't.",
    detail_one: 'The {{applied}} are saved. Nothing changed for the {{count}} below.',
    detail_other: 'The {{applied}} are saved. Nothing changed for the {{count}} below.',
  },
  stale: {
    summary: '{{applied}} of {{approved}} changes applied.',
    detail_one: '{{count}} was changed by someone else in the meantime.',
    detail_other: '{{count}} were changed by someone else in the meantime.',
    reason:
      '{{name}} changed it to {{value}} at {{time}}, before you approved, so I left it. Here it is again from the new value:',
  },
  undone: {
    summary_one: 'Undone. The {{count}} change is back to before.',
    summary_other: 'Undone. The {{count}} changes are back to before.',
    detail: 'The undo is recorded in the Amigo log and in Menu → Edit history too.',
  },
  summary: {
    average: '{{amount}} a dish on average',
    needs_look: 'Needs a look',
    nothing_else: 'Nothing else changes',
  },
  labels: {
    waiting: 'Waiting for approval',
    skip: 'Skip',
    unskip: 'Undo skip',
    approve_all: 'Approve all',
    approve_one: 'Approve {{count}}',
    approve_other: 'Approve {{count}}',
    approve_row: 'Approve',
    reject: 'Reject…',
    reject_confirm: 'Reject',
    back: 'Back',
    why: {
      amigo: 'Why not? (optional, Amigo reads this)',
      assistant: 'Why not? (optional, the assistant reads this)',
    },
    hint: 'Or reply below to change something.',
    show_all_one: 'Show all {{count}} changes',
    show_all_other: 'Show all {{count}} changes',
    show_less: 'Show fewer',
    applying_one: 'Applying {{count}} change…',
    applying_other: 'Applying {{count}} changes…',
    rows: {
      skipped: 'Skipped',
      applied: 'Applied',
      failed: 'Not applied',
      changed: 'Changed in the meantime',
      kept: 'Left as it is',
    },
    history: {
      amigo: 'Open in the Amigo log',
      assistant: "Open in the assistant's log",
    },
    undo: 'Undo',
    to: 'to',
    from: 'from',
    rejected: 'Rejected',
    replaced: 'Replaced',
    expired: 'Expired',
  },
};
